import { UpdateNotification } from '@/components/update/UpdateNotification';
import React from 'react';

export default class ChunkErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError(error: Error) {
    if (
      error.name === 'ChunkLoadError' ||
      error.message.includes('Failed to fetch dynamically imported module')
    ) {
      return { hasError: true };
    }
    return { hasError: false };
  }

  render() {
    if (this.state.hasError) {
      return (
        <UpdateNotification
          render={this.state.hasError}
          onUpdate={() => {
            window.location.reload();
          }}
        />
      );
    }

    return this.props.children;
  }
}
